'use strict';

var _ = require('lodash');
var SeasonalityReviewCalendarDataProvider = function SeasonalityReviewCalendarDataProvider($q, $filter, retrieverConstants, seasonColorService, dataRetrieverService, momentService, seasonalityCommonService, ConfigurationService, DowConstants, SpecialEventsService, seasonalityConstants, featureToggleService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var isDASeasonality = featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY');
  function retrieveData(market, calendarName, seasonalityType) {
    var m = market.split('-');
    var mode = seasonalityType && seasonalityType === seasonalityConstants.SEASONALITY_TYPE.POOLED ? retrieverConstants.SEASONALITY_ANALYSIS_CHART_HISTORICAL_POOLED : retrieverConstants.SEASONALITY_ANALYSIS_CHART_HISTORICAL;
    var rqlQuery = 'origin==' + m[0] + ';destination==' + m[1] + ';calendarName=="' + calendarName + '"';
    var params = [];
    return dataRetrieverService.getDataRetriever(retrieverConstants.SEASONALITY_SCREEN, mode).setCustomSearchCriteriaRules($q.when(rqlQuery)).setRequestParameters(params).localSortApplied().retrieveComponentData(mode);
  }
  function getLegendFromColors(colors) {
    return _.chain(ConfigurationService.getSeasons()).map(function (season) {
      return {
        label: season.name,
        fill: seasonColorService.getColor(season.name)
      };
    }).filter(function (o) {
      return _.includes(colors, o.fill);
    }).value();
  }
  function getLegendForSpecialEvents(specialEventsNames) {
    return _.chain(specialEventsNames).map(function (eventName) {
      return {
        label: eventName,
        fill: seasonColorService.getColor(eventName)
      };
    }).value();
  }
  function isArrayWithOneElement(data) {
    return _.isArray(data) && data.length === 1;
  }
  function transformData(data, spos, classGroup, overrides, cabin, significantPOS, seasonalityType) {
    if (!isArrayWithOneElement(data)) {
      return {
        data: undefined
      };
    }
    var sposClassGroupData;
    if (seasonalityType === seasonalityConstants.SEASONALITY_TYPE.POOLED) {
      sposClassGroupData = _.filter(data[0].outputs, {
        cabin: cabin,
        spos: significantPOS
      });
    } else if (isDASeasonality) {
      sposClassGroupData = _.filter(data[0].outputs, {
        cabin: cabin,
        classGroup: classGroup,
        spos: spos
      });
    } else {
      sposClassGroupData = _.filter(data[0].outputs, {
        classGroup: classGroup,
        spos: spos
      });
    }
    if (!sposClassGroupData || sposClassGroupData.length < 1) {
      return {
        data: undefined
      };
    }
    var specialEventsData = sposClassGroupData[0].specialEventDataPoints;
    var dataPoints = [];
    _.forEach(sposClassGroupData, function (entry) {
      dataPoints = _.concat(dataPoints, entry.weeklyDataPoints);
    });
    var dowGroups = data[0].dowGroups;

    //create seasonalityMap
    var seasonalityMap = {};
    _.forEach(dowGroups, function (dowGroup) {
      _.chain(dataPoints).filter({
        dowGroup: dowGroup.group
      }).sortBy('week').forEach(function (dataPoint) {
        if (!seasonalityMap[dataPoint.week]) {
          seasonalityMap[dataPoint.week] = {};
        }
        seasonalityMap[dataPoint.week][dataPoint.dowGroup] = seasonColorService.getColor(dataPoint.season);
      }).value();
    });

    //create dowGroupMap
    var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var dowGroupMap = {};
    _.forEach(weekdays, function (weekday, index) {
      _.every(dowGroups, function (dowGroup) {
        if (_.includes(dowGroup.dow, weekday)) {
          dowGroupMap[index] = dowGroup.group;
          return false;
        }
        return true;
      });
    });

    //create overridesMap for special adjustment
    var overridesMap = {};
    _.forEach(overrides, function (override) {
      if (override.year) {
        var dowGroup;
        if (override.dowGroup === 'All') {
          dowGroup = DowConstants.ALL_DOW_IDS;
        } else {
          dowGroup = override.dowGroup.split('_');
        }
        _.forEach(dowGroup, function (dow) {
          var year = override.year;
          var week = override.weekNo;
          var day = DowConstants.NAME_TO_ID[dow];
          var dayOfWeek = DowConstants.ID_TO_DAY_OF_WEEK[day];
          var date = momentService.of(year + ' ' + week + ' ' + dayOfWeek, momentService.TYPE.LOCAL_DATE, 'GGGG WW E');
          overridesMap[rmMomentFormat(date, 'DATE_ISO')] = seasonColorService.getColor(override.season);
        });
      }
    });

    //create dateToColorMap
    var dateToColorMap = createDateToColorMap(seasonalityMap, dowGroupMap, data, spos, classGroup, overrides, overridesMap, seasonalityType, cabin);
    var endYear = data[0].endDepartureDate.year();
    var startYear = data[0].startDepartureDate.year();
    _.forEach(specialEventsData, function (specialEventDataPoint) {
      var datesForLegendChange = [];
      var eventType = getSpecialTypeFromName(data[0], specialEventDataPoint.eventName);
      if (SpecialEventsService.isEventForContinuedYears(eventType)) {
        datesForLegendChange = SpecialEventsService.getDatesForContinuedEvents(startYear, endYear, specialEventDataPoint, eventType);
      } else {
        datesForLegendChange.push(_.split(specialEventDataPoint.departureDate, 'T')[0]);
      }
      _.forEach(datesForLegendChange, function (dates) {
        if (dateToColorMap[dates]) {
          dateToColorMap[dates] = seasonColorService.getColor(specialEventDataPoint.eventName);
        }
      });
    });
    return {
      dateToColorMap: dateToColorMap,
      legend: getLegendWithSpecialEvents(_.chain(specialEventsData).transform(function (result, se) {
        result.push(se.eventName);
      }).uniq().value(), dateToColorMap)
    };
  }
  function getSpecialTypeFromName(analysis, eventName) {
    var filteredEvents = _.find(analysis.specialEvents, {
      eventName: eventName
    });
    if (_.isArray(filteredEvents)) {
      return filteredEvents[0].eventType;
    } else {
      return filteredEvents.eventType;
    }
  }
  function getLegendWithSpecialEvents(specialEventsNames, dateToColorMap) {
    var uniqueColors = _.chain(dateToColorMap).map(function (mapObject) {
      return mapObject;
    }).uniq().value();
    return _.concat(getLegendFromColors(uniqueColors), getLegendForSpecialEvents(specialEventsNames));
  }
  function mapSeasonalityToDateRange(dateToColorMap, seasonalityMap, dowGroupMap, dateRange, spos, classGroup, overrides, overridesMap, seasonalityType, cabin) {
    var start = momentService.of(dateRange.from, momentService.FIELD.DEPARTURE_DATE);
    var end = momentService.of(dateRange.to, momentService.FIELD.DEPARTURE_DATE);
    var cur;
    function applyOverride(override) {
      var key = rmMomentFormat(cur, 'DATE_ISO');
      if (override.year === undefined) {
        dateToColorMap[key] = seasonColorService.getColor(override.season);
      }
      if (override.year === cur.year() && overridesMap[key]) {
        dateToColorMap[key] = overridesMap[key];
      }
    }
    var transformedOverrides = _.map(overrides, function (override) {
      if (override.weekNo === 0 || override.weekNo === 53) {
        var cloneOverride = _.clone(override);
        cloneOverride.weekNo = 52;
        return cloneOverride;
      }
      return override;
    });
    while (!start.isAfter(end)) {
      cur = start;
      var weekNum = seasonalityCommonService.seasonalityWeekOfYear(cur);
      dateToColorMap[rmMomentFormat(cur, 'DATE_ISO')] = seasonalityMap[weekNum][dowGroupMap[cur.day()]];

      //merge overrides
      if (transformedOverrides) {
        var filter = {
          dowGroup: dowGroupMap[cur.day()],
          significantPOS: spos,
          weekNo: parseInt(weekNum)
        };
        if (seasonalityType === seasonalityConstants.SEASONALITY_TYPE.POOLED) {
          filter.cabin = cabin;
        } else {
          filter.classGroup = classGroup;
        }
        var availableOverrides = _.filter(transformedOverrides, filter);
        if (availableOverrides && availableOverrides.length > 0) {
          _.chain(availableOverrides).sortBy('year').reverse().forEach(applyOverride).value();
        }
      }
      start = start.add(1, 'days');
    }
  }
  function createDateToColorMap(seasonalityMap, dowGroupMap, data, spos, classGroup, overrides, overridesMap, seasonalityType, cabin) {
    var dateToColorMap = {};
    var historicalDateRange = {
      from: rmMomentFormat(data[0].startDepartureDate, 'DATE_ISO'),
      to: rmMomentFormat(data[0].endDepartureDate, 'DATE_ISO')
    };
    var currentYear = momentService.now(momentService.FIELD.DEPARTURE_DATE).year();
    var currentDateRange = {
      from: currentYear + '-01-01',
      to: currentYear + '-12-31'
    };
    var currentPlusDateRange = {
      from: currentYear + 1 + '-01-01',
      to: currentYear + 1 + '-12-31'
    };
    mapSeasonalityToDateRange(dateToColorMap, seasonalityMap, dowGroupMap, historicalDateRange, spos, classGroup, overrides, overridesMap, seasonalityType, cabin);
    mapSeasonalityToDateRange(dateToColorMap, seasonalityMap, dowGroupMap, currentDateRange, spos, classGroup, overrides, overridesMap, seasonalityType, cabin);
    mapSeasonalityToDateRange(dateToColorMap, seasonalityMap, dowGroupMap, currentPlusDateRange, spos, classGroup, overrides, overridesMap, seasonalityType, cabin);
    return dateToColorMap;
  }
  function getData(calendar, seasonalityType) {
    return retrieveData(calendar.market, calendar.calendarName, seasonalityType).then(function (data) {
      return transformData(data, calendar.spos, calendar.classGroup, calendar.overrides, calendar.cabin, calendar.spos, seasonalityType);
    });
  }
  return {
    getData: getData,
    getLegendFromColors: getLegendFromColors
  };
};
SeasonalityReviewCalendarDataProvider.$inject = ['$q', '$filter', 'DataRetrieverConstantsService', 'SeasonColorService', 'DataRetrieverService', 'MomentService', 'SeasonalityCommonService', 'ConfigurationService', 'DowConstants', 'SpecialEventsService', 'SeasonalityConstants', 'FeatureToggleService'];
module.exports = SeasonalityReviewCalendarDataProvider;